<template>
  <section class="section">
    <div class="container">
      <div class="tabs is-right" id="menureportes">
        <ul>
          <router-link tag="li" :to="{ name: 'configprojects.projects' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Proyectos</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'configprojects.empresas' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Empresas</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Proyectos</h1>
          <h2 class="subtitle is-6">Proyectos de desarrollo de software</h2>
          <p>En este módulo podrá configurar el modulo de proyectos</p>
        </div>
      </div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  border-bottom-width: 2px;
  color: #3273dc;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["tokenUser"]),
    isinicial() {
      return this.$route.name === "configprojects";
    },
  },
  methods: {},
};
</script>

<style lang='scss'>
@media print {
  #menureportes {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/proyectos/configuracion/Configuracion.vue